// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"354":"395b3c43","780":"5da55ad0","838":"9cec5a0f"}[chunkId] + ".chunk.js";
};